const getters = {
  getNavOne: state => state.navOne,
  getNavTwo: state => state.navTwo,
  getToken: state => state.user.token,
  getTokenUser:state => state.user.loginUser.tokenUser,
  getIsNewUser:state=>state.user.loginUser.is_new_user,
  getErrorTip:state => state.user.errorTip,
  getName: state => state.user.name,
  // name: state => state.name,
  getPwd: state => state.user.pwd,
  getId: state => state.user.id,
  getPermission: state => state.user.permission,
  // getRoles: state => state.user.roles,
  // getLoginName:state=>state.user.loginUser.loginName,
  getPassword:state=>state.user.loginUser.password,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters
};
export default getters
